import React, { useEffect, useState } from "react";
import OshaViewReportList from "../component/oshaViewReportList";
import { useNavigate } from "react-router-dom";
import { PAGE_SIZE } from "../../../constant/constant";
import * as incidentAction from "../../../redux/actions/incidentAction";
import { useSelector, useDispatch } from "react-redux";
import {
  ACCESS_DENIED,
  OSHA_VIEW_REPORT,
  OSHA_VIEW_REPORT_LIST,
} from "../../../constant/routeContant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { getPreviousRoute } from "../../../utils/routeTracker";

const OshaViewReportListContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [shouldRestoreState, setShouldRestoreState] = useState(null);
  const establishmentId = null;
  const year = 2024;
  const getListAddedInOSHAData = (data) => {
    dispatch(incidentAction.getListAddedInOSHA(data));
    dispatch(incidentAction.getListAddedInOshaFilterObj(data));
  };

  const listAddedInOSHA = useSelector((state) => state.getListAddedInOSHA);
  const isLoader = useSelector((state) => state.getListAddedInOSHA.isLoading);
  useEffect(() => {
    const defaultData = {
      establishmentId: establishmentId,
      year: "",
      status: "",
      search: "",
      page: 1,
      pageSize: PAGE_SIZE,
    };

    const previousRoute = getPreviousRoute();
    const preserveRoutes = [OSHA_VIEW_REPORT_LIST, OSHA_VIEW_REPORT];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("oshaViewReportListPreserveState") === "true";
    sessionStorage.removeItem("oshaViewReportListPreserveState");

    if (isFromPreserveRoute && listAddedInOSHA?.filterObj) {
      setShouldRestoreState(true);
      getListAddedInOSHAData(listAddedInOSHA.filterObj);
    } else {
      setShouldRestoreState(false);
      getListAddedInOSHAData(defaultData);
    }
  }, []);

  const handleViewOnClick = (rows) => {
    sessionStorage.setItem("oshaViewReportListPreserveState", "true");
    navigate(OSHA_VIEW_REPORT, {
      state: { row: rows, editMode: false },
    });
  };


  return (
    <>
      {checkPrivileges([12, 152, 153, 154]) ? (
        <OshaViewReportList
          establishmentId={establishmentId}
          year={year}
          isLoading={isLoader}
          listAddedInOSHA={listAddedInOSHA?.data}
          handleViewOnClick={handleViewOnClick}
          getListAddedInOSHAData={getListAddedInOSHAData}
          listAddedInOSHAs={listAddedInOSHA}
          shouldRestoreState={shouldRestoreState}
        />
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default OshaViewReportListContainer;
